module.exports = __webpack_public_path__ + "static/img/d-extension.e1864580.png";